<template>
  <modal-select
    ref="modalSelect"
    v-model="valueDirty"
    :items="filteredAssignables"
    :loading="isLoading"
    item-text="name"
    :dialog-title="dialogTitle"
    :multiple="multiple"
    :force-dialog="forceDialog"
    :dialog-only="dialogOnly"
    :dialog-visible.sync="dialogVisibleDirty"
    :is-same-item="isSameItem"
    :get-value-property="getValueProperty"
    :error-messages="errorMessages"
    v-bind="$attrs"
    @opened="focusSearch"
    @submit="$emit('submit')"
  >
    <template
      v-if="!dialogOnly"
      v-slot:dropdownSelectItem="{ item: assignee }"
    >
      <v-list-item-avatar>
        <v-icon>
          {{ assigneeTypeData[assignee.type].icon }}
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>
          {{ assignee.name }}
        </v-list-item-title>
      </v-list-item-content>
    </template>
    <template v-slot:filters>
      <v-row no-gutters>
        <v-col cols="8">
          <v-select
            v-model="filters.type"
            class="mb-1"
            solo
            label="Search by type"
            clearable
            :items="types"
            :disabled="!!type"
            hide-details
            item-value="key"
            item-text="label"
          />
        </v-col>
        <v-col cols="8">
          <v-text-field
            ref="nameSearch"
            v-model="filters.name"
            placeholder="Search by name"
            clearable
            hide-details
            autofocus
            autocomplete="disable"
            solo
          />
        </v-col>
      </v-row>
    </template>
    <template v-slot:dialogItem="{ item: assignee, selected: selected, selectItem: selectItem }">
      <v-list-item
        :key="assignee.type + '_' + assignee.id"
        class="list--bordered"
        :class="{ 'grey lighten-4': selected }"
        @click="selectItem(assignee)"
      >
        <v-list-item-avatar>
          <v-icon :color="selected ? 'primary' : undefined">
            {{ assigneeTypeData[assignee.type].icon }}
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title :class="{ 'primary--text font-weight-bold': selected }">
            {{ assignee.name }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action v-if="selected">
          <v-avatar
            color="success"
            size="26px"
          >
            <v-icon
              color="white"
              small
            >
              check
            </v-icon>
          </v-avatar>
        </v-list-item-action>
      </v-list-item>
    </template>
    <template v-slot:noData>
      There are no results for your search
    </template>
  </modal-select>
</template>

<script>
  import ModalSelect from '@/components/helpers/ModalSelect'
  import { mapState, mapGetters } from 'vuex'
  import ServiceTask from '@/models/ServiceTask'

  export default {
    name: 'AssigneeModalSelect',
    components: { ModalSelect },
    props: {
      value: {
        type: [Object, Array],
        default: null
      },
      multiple: {
        type: Boolean,
        default: false
      },
      dialogTitle: {
        type: String,
        default: 'Select assignee'
      },
      forceDialog: {
        type: Boolean,
        default: false
      },
      dialogOnly: {
        type: Boolean,
        default: false
      },
      dialogVisible: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: undefined
      },
      errorMessages: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        filters: {
          name: null,
          type: null
        },
        types: [
          {
            key: 'staff',
            label: 'Staff'
          },
          {
            key: 'contractor',
            label: 'Contractors'
          }
        ],
        assigneeTypeData: ServiceTask.assigneeTypeData
      }
    },
    computed: {
      valueDirty: {
        set: function (value) {
          this.$emit('input', value)
        },
        get: function () {
          return this.value
        }
      },
      dialogVisibleDirty: {
        set: function (value) {
          this.$emit('update:dialogVisible', value)
        },
        get: function () {
          return this.dialogVisible
        }
      },
      filteredAssignables() {
        return this.allAssignables
          .filter(assignable => {
            return this.filters.type ? assignable.type === this.filters.type : true
          }).filter(assignable => {
            return this.filters.name ? (assignable.name && assignable.name.toLocaleLowerCase().includes(this.filters.name.toLocaleLowerCase())) : !!assignable.name
          })
      },
      isLoading() {
        return this.staff.loading || this.contractors.loading
      },
      ...mapState('service', ['staff', 'contractors']),
      ...mapGetters('service', ['allAssignables'])
    },
    watch: {
      type: function(value) {
        if (value) this.filters.type = value
      }
    },
    created() {
      if (this.type) this.filters.type = this.type
    },
    methods: {
      isSameItem(item, otherItem) {
        return item.id === otherItem.id && item.type === otherItem.type
      },
      getValueProperty(item) {
        return `${item.type}:${item.id}`
      },
      focusSearch() {
        this.$refs.nameSearch.$el.querySelector('input').focus()
      }
    }
  }
</script>
